<template>
  <vx-card no-shadow v-if="showWindow">
    <vs-table max-items="5" pagination :data="tableData">
            <template slot="thead">
                <vs-th>event</vs-th>
                <vs-th>status</vs-th>
                <vs-th>summary</vs-th>
                <vs-th>last updated</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                   <vs-td :data="data[indextr].event">
                        {{data[indextr].event}}
                    </vs-td>
                    <vs-td :data="data[indextr].status">
                        {{data[indextr].status}}
                    </vs-td>
                    <vs-td :data="data[indextr].summary">
                        {{data[indextr].summary}}
                    </vs-td>
                    <vs-td :data="data[indextr].last_updated">
                        {{data[indextr].last_updated}}
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
  </vx-card>
</template>

<script>
import axios from "@/axios.js"
import vSelect from 'vue-select';
import saleStatus from '../../../resources/sale_status.json';
export default {
  data() {
    return {
      popupActive: false,
      params: {},
      saleStatus:saleStatus,
      tableData:[]
    }
  },
  components:{
    'v-select': vSelect,
  },
  computed: {
    showWindow(){
      if(this.$route.path.indexOf('/clients/')!==-1){
        //if(this.fieldsData.length===0)
          this.setData();
        return true;
      }
      return false;
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
  },
  methods:{
    setData: function(){
      let that = this;
      const params = new URLSearchParams();
      params.append('type', 'get-dashboard');
      params.append('email', this.$route.params.email);
      axios.post("/api/client",params)
      .then((response) => {
        that.tableData.splice(0);
        for(let i in response.data){
          let data = JSON.parse(response.data[i].object);
          this.tableData.push(data);
        }
      })
      .catch((error) => { console.log('error',error) })
    },
  }
}
</script>
